import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { JourneyItem } from "../Journey/journey.types";
// import { parseDynamoItem } from "../utils/dynamoParser";
import { parseDynamoItem } from "../utils/parseDynamoItem";

const API_BASE = "https://admin-dashboard-backend-sbu4.onrender.com/api";

export const useBatchJourney = (batchNo: string) => {
  const [journeys, setJourneys] = useState<JourneyItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchJourney = useCallback(async () => {
    if (!batchNo) return;

    try {
      setLoading(true);
      setError(null);
      const res = await axios.get(`${API_BASE}/batch/${batchNo}/journey`);

      const parsed = res.data.data.map((j: any) => parseDynamoItem(j));

      setJourneys(parsed);
    } catch (err) {
      console.error("Failed to load journey", err);
      setError("Failed to load journey history");
    } finally {
      setLoading(false);
    }
  }, [batchNo]);

  useEffect(() => {
    fetchJourney();
  }, [fetchJourney]);

  return { journeys, loading, error, refetch: fetchJourney };
};